import { render, staticRenderFns } from "./merdeka-center-result.vue?vue&type=template&id=2398f9be&scoped=true"
import script from "./merdeka-center-result.vue?vue&type=script&lang=js"
export * from "./merdeka-center-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398f9be",
  null
  
)

export default component.exports